import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    window.history.scrollRestoration = 'manual';
    if (hash) {
      const id = hash.replace('#', '');
      
      const scrollToElement = (attempts = 0) => {
        const element = document.getElementById(id);
        
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (attempts < 10) {
          setTimeout(() => scrollToElement(attempts + 1), 100);
        }
      };
      
      scrollToElement();
    } else {
      window.scrollTo(0, 0);
      setTimeout(() => {
        document.body.scrollTo({ top: 0, behavior: 'smooth' });
      }, 10);
    }
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
